import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import BlockHeadlineComponent from '../Headline/BlockHeadlineComponent';
import Confetti from '../../../../utilities/confetti';
import {createReportUpdateCellularPlan} from '../../../../utilities/reports/createReport';
import likeIcon from '../images/like/like.svg';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import UploadFile from '../../../Shared/UploadFile/UploadFile';
import {gtag4} from '../../../../utilities/analytics/tracking';
import {gAChangePPSuccessPageLimited, gAChangePPSuccessPage} from '../reports/gaReports';
import {convertDateTimeToDate} from '../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';

const CompletedSuccessfulComponent = ({props, backToPrivateArea}) => {
  let desc = props.data.isOwnerChanged
    ? 'החבילה תיכנס לתוקף באופן מיידי'
    : `החבילה תיכנס לתוקף<br/> במחזור חיוב הבא ${props.data.selectedAccount.billCycle}`;

  if (props.data.selectedAccount?.newPackage?.isImmediateTransitionPlan) {
    desc = `החבילה תיכנס לתוקף החל מהיום ${convertDateTimeToDate(new Date())} `;
  }

  function backToHomePage() {
    window.location.href = Config.staticWebSiteUrl;
  }

  // function getTomorrowDate() {
  //   const tomorrowDate = new Date();
  //   tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  //   return tomorrowDate;
  // }

  useEffect(() => {
    if (props.data.selectedAccountExtendedData?.banlvl_pp_limited == 'Y') {
      gAChangePPSuccessPageLimited();
    } else {
      gAChangePPSuccessPage();
    }
    if (!props.data.selectedMarketPackage) {
      gtag4({
        event: 'CellPackUpdateP2_Step15_SuccessPage',
        step: '15',
        title: 'החבילה החדשה עודכנה בהצלחה!',
        action: 'SuccessPage',
      });
    } else {
      gtag4({
        event: 'CellPackUpdateP1_Step12_SuccessPage',
        step: '12',
        title: 'החבילה החדשה עודכנה בהצלחה!',
        action: 'SuccessPage',
      });
    }

    props.clearHistory();
  }, []);

  useEffect(() => {
    const customerName = props.userData?.loginData?.userDetails?.firstName + ' ' + props.userData?.loginData?.userDetails?.lastName;
    const subscriber = props.userData?.loginData?.userDetails?.contactNumber;
    const idNumber = props.userData?.loginData?.userDetails?.IDNumber;

    createReportUpdateCellularPlan(
      'Success',
      props.data?.selectedAccount?.newPackage?.offerID,
      props.data?.allCellularPackagesForAccountData[0]?.pricePlan,
      props.data?.selectedAccountExtendedData?.banlvl_pp_limited,
      customerName,
      subscriber,
      idNumber,
    );
  }, []);

  return (
    <div className='successful-container'>
      <Confetti />

      <div className='mt-5 mr-auto ml-auto d-flex flex-column align-items-center'>
        <Image className={'mt-4 mb-5'} src={likeIcon} />

        <BlockHeadlineComponent
          currentStep={props.currentStep}
          mainText='החבילה החדשה <br/> עודכנה בהצלחה!'
          description={desc}
          className={props.data?.selectedAccount?.newPackage?.isBenefitsForSoldiers ? 'solder-benefit' : ''}
        />
      </div>

      {props.iContent.includeBanner.value && (
        <div className='d-flex justify-content-center banner-wrapper text-center '>
          <a className='w-100 h-100 banner' href={props.iContent.bannerUrl.value}></a>
        </div>
      )}

      {props.data?.selectedAccount?.newPackage?.isBenefitsForSoldiers && (
        <div className='idf-discount-wrapper'>
          <UploadFile
            phoneNumber={props.data.selectedAccount?.subscriberNo}
            text={props.data?.selectedAccount?.newPackage?.fileUpload?.expandedValue?.[0]?.description?.value || ''}
            codeFile={props.data?.selectedAccount?.newPackage?.fileUpload?.expandedValue?.[0]?.nameFile?.value || ''}
          />
        </div>
      )}

      <div className='d-flex justify-content-center'>
        {props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated ? (
          <BtnSubmit text='סיום' onclick={backToPrivateArea} />
        ) : (
          <BtnSubmit text='סיום' onclick={backToHomePage} />
        )}
      </div>
    </div>
  );
};

export default CompletedSuccessfulComponent;
